export type TInterviewThreadApiErrorKind =
    "network"|"validation"|"forbidden"|"notFound"|"server"|"timeout";

export type TInterviewThreadApiError = {
    kind: TInterviewThreadApiErrorKind,
    message: string,
    status?: number,
    retryable: boolean,
};

export default class InterviewThreadApiError extends Error {

    constructor(
        public readonly detail: TInterviewThreadApiError,
    ) {
        super(detail.message);
        this.name = "InterviewThreadApiError";
        Object.setPrototypeOf(this, InterviewThreadApiError.prototype);
    }

}

export function toInterviewThreadApiError(
    error: unknown,
    fallbackMessage: string,
): TInterviewThreadApiError {
    if (error instanceof InterviewThreadApiError) {
        return error.detail;
    }

    return {
        kind: "network",
        message: fallbackMessage,
        retryable: true,
    };
}
